import { render, staticRenderFns } from "./netBusiness.vue?vue&type=template&id=6f3700ee"
import script from "./netBusiness.vue?vue&type=script&lang=js"
export * from "./netBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports